import { useState, useEffect } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setCredentials } from "./authSlice";
import { useLoginMutation } from "./authApiSlice";
import usePersist from "../../hooks/usePersist";
import useTitle from "../../hooks/useTitle";
import PulseLoader from "react-spinners/PulseLoader";
import { FaEye, FaEyeSlash, FaUserAlt } from "react-icons/fa";
import { IoLockClosedOutline } from "react-icons/io5";
import useAuth from "../../hooks/useAuth";
import Turnstile from "react-turnstile";

const siteKey = process.env.REACT_APP_TURNSTILE_SITE_KEY;
// console.log("hello sitekey", siteKey);
const Login = () => {
  useTitle("Vizta");
  const [searchParams] = useSearchParams();
  const incomingUser = searchParams.get("user");
  const defaultPassword = searchParams.get("dp");
  // console.log(defaultPassword);
  let incomingPassword = null;
  if (defaultPassword === "Y") {
    // console.log("default password");
    incomingPassword = "123456";
  }

  const [showPassword, setShowPassword] = useState(false);
  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const location = useLocation();
  const from = location.state?.from
    ? `${location.state.from.pathname}${location.state.from.search}`
    : "/home/dash";

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [persist, setPersist] = usePersist();
  const [username, setUsername] = useState();
  const [password, setPassword] = useState();
  const [responseContent, setResponseContent] = useState("");
  const [login, { data, isLoading, isError, isSuccess, error }] =
    useLoginMutation();

  const handleUserInput = (e) => setUsername(e.target.value);
  const handlePwdInput = (e) => setPassword(e.target.value);
  const handleToggle = () => setPersist((prev) => !prev);
  const { roles } = useAuth();

  if (roles.length) {
    navigate(from, { replace: true });
  }

  useEffect(() => {
    setResponseContent(null);
  }, [username, password]);

  // useEffect(() => {
  //   // console.log(incomingPassword);
  //   // console.log(incomingUser);

  //   const name = incomingUser ?? "parag";
  //   const password = incomingPassword ?? "parag";
  //   setPassword(password);
  //   setUsername(name);
  // }, []);
    useEffect(() => {
    setPassword(incomingPassword);
    setUsername(incomingUser);
  }, []);

  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  // Handle reCAPTCHA verification
  const handleCaptchaChange = (token) => {
    if (token) {
      setTimeout(() => {
        setCaptchaVerified(true);
        setErrorMessage("");
      }, 1000); // 1 second = 1000 milliseconds
    } else {
      setCaptchaVerified(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const userData = await login({
        user: username,
        pwd: password,
      }).unwrap();
      const { accessToken, userCompanylogo, name } = userData;
      dispatch(setCredentials({ accessToken }));

      // Store accessToken in localStorage
      localStorage.setItem("accessToken", accessToken);
      // localStorage.setItem("userLogo", userCompanylogo);

      const userCompanyDetails = { userCompanylogo, name };
      localStorage.setItem(
        "userCompanyDetails",
        JSON.stringify(userCompanyDetails)
      );

      navigate(from, { replace: true });
    } catch (err) {
      console.error("Failed to login", err);
      setResponseContent(
        <div
          className={`text-red-600 text-xl font-medium w-[95%] text-center bg-red-200 border border-red-600 rounded-lg flex items-center justify-center py-[0.8rem]`}
        >
          Login failed. Please try again.
        </div>
      );
    }
  };

  const navigateToForgotPwdPage = () => {
    navigate("../forget");
  };

  useEffect(() => {
    if (isError) {
      setResponseContent(
        <div
          className={`text-red-600 text-xl font-medium w-[95%] text-center bg-red-200 border border-red-600 rounded-lg flex items-center justify-center py-[0.8rem]`}
        >
          {error.data}
        </div>
      );
    } else if (isSuccess) {
      const { accessToken } = data;
      dispatch(setCredentials({ accessToken }));
      navigate("/login"); // Navigate to dashboard on success
    } else {
      setResponseContent(null);
    }
  }, [isError, error, isSuccess, data, dispatch, navigate]);

  if (isLoading) return <PulseLoader color={"#FFF"} />;

  return (
    <div className="flex flex-col items-center justify-center min-h-screen py-4 bg-gray-100">
      <main className="w-full max-w-4xl flex flex-col lg:flex-row bg-white shadow-md rounded-lg overflow-hidden">
        {/* left-side */}
        <section className="flex flex-col justify-evenly items-center lg:w-1/2 p-4">
          {responseContent ? (
            responseContent
          ) : (
            <img src="/assets/viz.png" alt="" className="w-1/2 mb-4" />
          )}
          <form
            onSubmit={handleSubmit}
            className="w-full flex flex-col gap-4 items-center"
          >
            <div className="text-2xl font-medium text-blue-950 w-full text-center mb-2">
              <h1>Login</h1>
              <p className="text-lg font-normal">Please login to continue</p>
            </div>
            {/* hi parag */}
            <div className="w-full flex flex-col gap-4">
              <div className="relative w-full">
                <FaUserAlt className="absolute top-1/2 left-3 transform -translate-y-1/2 text-gray-500" />
                <input
                  onChange={handleUserInput}
                  value={username}
                  name="user"
                  className="text-lg rounded border border-gray-300 px-10 py-2 w-full"
                  type="text"
                  placeholder="enter your username"
                />
              </div>

              <div className="relative w-full">
                <IoLockClosedOutline className="absolute top-1/2 left-3 transform -translate-y-1/2 text-gray-500" />
                <input
                  type={showPassword ? "text" : "password"}
                  onChange={handlePwdInput}
                  value={password}
                  name="pwd"
                  className="text-lg rounded border border-gray-300 px-10 py-2 w-full"
                  placeholder="enter your password"
                />
                <span
                  className="absolute top-1/2 right-3 transform -translate-y-1/2 cursor-pointer"
                  onClick={handleTogglePasswordVisibility}
                >
                  {showPassword ? (
                    <FaEyeSlash fill="#4e4e52" />
                  ) : (
                    <FaEye fill="#4e4e52" />
                  )}
                </span>
              </div>

              <div className="w-full flex items-center justify-center scale-[0.8]">
                {/* <Turnstile
                  sitekey={siteKey}
                  theme="light"
                  onSuccess={handleCaptchaChange}
                  onError={() => setCaptchaVerified(false)}
                  onExpire={() => setCaptchaVerified(false)}
                /> */}
              </div>

              <button
                className={`w-full py-2 rounded text-lg font-medium mt-4 transition-all duration-300 text-white bg-blue-950`}
                type="submit"
                disabled={isLoading}
              >
                LOGIN
              </button>

              <div className="flex items-center justify-end w-full mt-2">
                <button
                  className="text-blue-600"
                  onClick={navigateToForgotPwdPage}
                  type="button"
                >
                  Forgot Password?
                </button>
              </div>

              <p className="text-center mt-4 text-sm">
                By logging in, you agree to our{" "}
                <span className="text-blue-600">Terms of Service</span> and{" "}
                <span className="text-blue-600">Privacy Policy</span>
              </p>
            </div>
          </form>
        </section>
        {/* right-side */}
        <section className="lg:w-1/2 flex flex-col items-center justify-center bg-gray-200 p-4">
          <h2 className="text-2xl lg:text-3xl text-center mb-4">
            Data Visualized, Decisions Amplified
          </h2>
          <img
            src="/assets/Data-report.png"
            alt="dataReport"
            className="w-3/4 mb-4"
          />
          <p className="text-lg font-medium text-center">
            Decision thrive when rooted in data. Harness the power of insights
            to drive informed choices and unlock unparalleled success.
          </p>
        </section>
      </main>
    </div>
  );
};

export default Login;
